import { render, staticRenderFns } from "./SpecializedTable.vue?vue&type=template&id=7272306c"
import script from "./SpecializedTable.vue?vue&type=script&lang=js"
export * from "./SpecializedTable.vue?vue&type=script&lang=js"
import style0 from "./SpecializedTable.vue?vue&type=style&index=0&id=7272306c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports